import { render, staticRenderFns } from "./SearchBuildingResult.vue?vue&type=template&id=71271954&scoped=true&lang=pug&"
import script from "./SearchBuildingResult.vue?vue&type=script&lang=ts&"
export * from "./SearchBuildingResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71271954",
  null
  
)

export default component.exports